import filter from "lodash.filter"

export function myMax(obj, varName) {
  try {
    return obj.reduce((prev, curr) => prev[varName] < curr[varName] ? curr : prev)[varName]
  } catch {
    return 0
  }
}


export function myMin(obj, varName) {
  try {
    return obj.reduce((prev, curr) => prev[varName] > curr[varName] ? curr : prev)[varName]
  } catch {
    return 0
  }
}


export function filterObj(obj, filterDict) {
  const out = filter(obj, filterDict)
  return out
}

